import { render, staticRenderFns } from "./selectLabourer.vue?vue&type=template&id=451b2a00&scoped=true"
import script from "./selectLabourer.vue?vue&type=script&lang=js"
export * from "./selectLabourer.vue?vue&type=script&lang=js"
import style0 from "./selectLabourer.vue?vue&type=style&index=0&id=451b2a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b2a00",
  null
  
)

export default component.exports